import { Injectable, Component } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SearchOverlayService {

  toggleSeekerListener = new Subject<any>();

  constructor() { }

  public listenSeekerStatus() {
    return this.toggleSeekerListener.asObservable();
  }

  public toggleSeeker() {
    this.toggleSeekerListener.next();
  }
}
